<template>
  <div style="margin: 20px">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>故障通知</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 状态 -->
    <el-tabs
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
      class="tabs_style"
    >
      <el-tab-pane label="待处理" name="first">
        <!-- 查询 -->

        <el-form :inline="true" :model="formInline">
          <!-- <el-form-item label="客户手机号:">
            <el-input size="small" v-model="formInline.phone" placeholder="输入客户手机号"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="客户名:">
            <el-input size="small" v-model="formInline.customer_name" placeholder="输入客户名"></el-input>
          </el-form-item> -->
          <el-form-item label="车辆编号:">
            <el-input
              size="small"
              v-model="formInline.car_id"
              placeholder="输入车辆编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="开始结束时间:">
            <div class="block">
              <el-date-picker
                v-model="formInline.upend_time"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['12:00:00', '08:00:00']"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="search"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>

        <el-table
          size="small"
          :data="listData"
          highlight-current-row
          border
          style="width: 100%"
        >
          <el-table-column
            align="center"
            prop="id"
            label="ID"
            width="80"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="car_id"
            width="200"
            label="车辆编号"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="customer_name"
            width="100"
            label="客户名"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            width="150"
            label="联系方式"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="fault_name"
            width="150"
            label="故障系统名"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="fault_detailed"
            width="200"
            label="详细故障"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="car_position"
            width="250"
            label="车辆位置"
          >
            <div slot-scope="scope">
              <span class="car_jl">{{ scope.row.car_position }}</span>
              <el-button
                size="mini"
                icon="el-icon-location"
                type="warning"
                circle
                @click="showmap(scope.row)"
              >
              </el-button>
            </div>
          </el-table-column>

          <el-table-column
            align="center"
            prop="problem_dascribe"
            width="300"
            label="问题描述"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="hand_opinion"
            width="300"
            label="处理意见"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="status"
            width="150"
            label="状态"
          >
            <template slot-scope="scope">
              <el-tag size="small" type="danger">{{ scope.row.status }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-edit"
                circle
                @click="handleEdit(scope.row)"
              >
              </el-button>
              <el-button
                size="mini"
                type="success"
                icon="el-icon-check"
                circle
                @click="handleStatus(scope.row)"
              >
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <Pagination
          v-bind:child-msg="pageparm"
          @callFather="callFather"
        ></Pagination>
      </el-tab-pane>

      <el-tab-pane label="已处理" name="second">
        <!-- 查询 -->
        <el-form :inline="true" :model="successFormInline">
          
          <el-form-item label="车辆编号:">
            <el-input
              size="small"
              v-model="successFormInline.car_id"
              placeholder="输入车辆编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="开始结束时间:">
            <div class="block">
              <el-date-picker
                v-model="successFormInline.upend_time"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['12:00:00', '08:00:00']"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="searchSuccess"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
        <!-- 列表 -->
        <el-table
          size="small"
          :data="tableData"
          highlight-current-row
          border
          style="width: 100%"
        >
          <el-table-column
            align="center"
            prop="id"
            label="ID"
            width="80"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="car_id"
            width="200"
            label="车辆编号"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="customer_name"
            width="100"
            label="客户名"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            width="150"
            label="联系方式"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="fault_name"
            width="200"
            label="故障系统名"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="fault_detailed"
            width="200"
            label="详细故障"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="car_position"
            width="250"
            label="车辆位置"
          >
            <div slot-scope="scope">
              <span class="car_jl">[113.25784,119.23456]</span>
              <el-button
                size="mini"
                icon="el-icon-location"
                type="warning"
                circle
                @click="showmap(scope.row)"
              >
              </el-button>
            </div>
          </el-table-column>
          <el-table-column
            align="center"
            prop="problem_dascribe"
            width="300"
            label="问题描述"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="hand_opinion"
            width="200"
            label="处理意见"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="status"
            width="200"
            fixed="right"
            label="状态"
          ></el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_parm.currentPage"
          background
          :page-sizes="[5, 10, 15, 25, 50, 100]"
          :page-size="page_parm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page_parm.total"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <!-- 编辑弹框 -->
    <el-dialog
      title="编辑故障工单"
      :visible.sync="dialogFormVisible"
      width="25%"
      :close-on-click-modal="false"
    >
      <div style="margin-right: 5%">
        <el-form :model="form">
          <el-form-item label="处理意见" label-width="120px">
            <el-input
              type="textarea"
              size="mini"
              v-model="form.hand_opinion"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="运维人员" label-width="120px">
            <el-select
              size="mini"
              v-model="form.name"
              @click="editClick()"
              filterable
              clearable
              placeholder="请选择运维人员"
            >
              <el-option
                v-for="item in options"
                :key="item.index"
                :label="item.value"
                :value="item.key"
              ></el-option>
              <el-pagination
                @size-change="handleSizeChangeOp"
                @current-change="handleCurrentChangeOp"
                :current-page="pageop.currentPage"
                :page-sizes="[5, 10, 15, 25, 50, 100]"
                :page-size="pageop.pageSize"
                :pager-count="5"
                layout="prev, pager, next"
                :total="pageop.total"
              ></el-pagination>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="margin-left: 10%">
          <el-button size="mini" type="primary" @click="submitEdit"
            >确 定</el-button
          >
          <el-button size="mini" @click="dialogFormVisible = false"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 地图 -->
    <el-dialog
      :visible.sync="show"
      title="车辆位置"
      :close-on-click-modal="false"
    >
      <div id="container"></div>
    </el-dialog>

    <!-- 故障处理 -->
    <el-dialog
      title="提交"
      :visible.sync="dialogFault"
      width="30%"
      :before-close="handleFaultClose"
    >
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFault = false">取 消</el-button>
        <el-button type="primary" @click="dialogFault = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 故障工单提交 -->
  </div>
</template>
<script>
let conmap = "";
import AMapLoader from "@amap/amap-jsapi-loader";
import Pagination from "../../components/Pagination";

export default {
  data() {
    return {
      dialogFault: false,
      dialogVisible: false,
      dialogFormVisible: false,
      show: false,
      activeName: "first",
      listData: [],
      tableData: [],
      formInline: {
        phone: "",
        customer_name: "",
        car_id: "",
        upend_time: [],
        page: 1,
        limit: 10,
      },
      successFormInline: {
        phone: "",
        customer_name: "",
        car_id: "",
        upend_time: [],
        page: 1,
        limit: 10,
      },
      opInline: {
        page: 1,
        limit: 5,
      },
      options: [],
      form: {
        id: "",
        hand_opinion: "",
        name: "",
        ops: "",
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      page_parm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      pageop: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  components: {
    Pagination,
  },
  created() {
    this.getdata();
    this.getSuccessdata();
  },
  methods: {
    // 故障工单

    handleFaultClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 地图
    showmap() {
      this.show = !this.show;
      AMapLoader.load({
        key: "872899e98d8b442ed41d45612fd91d4b", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: "", // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then((AMap) => {
        // var center_path = result.locations;
        conmap = new AMap.Map("container", {
          //设置地图容器id
          viewMode: "3D", //是否为3D地图模式
          zoom: 15, //初始化地图级别
          center: [116.397428, 39.90923], //初始化地图中心点位置
        });
        var lnglat = [116.397428, 39.90923];
        AMap.convertFrom(lnglat, "gps", function (status, result) {
          if (result.info === "ok") {
            var resLnglat = result.locations[0];
            let m2 = new AMap.Marker({
              position: resLnglat,
            });
            conmap.add(m2);
            // 设置标签
            m2.setLabel({
              offset: new AMap.Pixel(20, 20),
            });
          }
        });
      });
    },
    //待处理列表
    getdata(parm) {
      this.loading = true;
      let res = {
        data: [
          {
            car_id: "01",
            customer_name: "小赞",
            phone: "15153448633",
            fault_name: "转向系统",
            fault_detailed: "11111111",
            car_position: "[118.2099,36.810004] ",
            problem_dascribe: "转向转向",
            hand_opinion: "无",
            status: "待处理",
          },
        ],
      };
      this.loading = false;
      this.listData = res.data;
    },
    
    //已处理列表
    getSuccessdata(parm) {
      this.loading = true;
      let res = {
        data: [
          {
            car_id: "01",
            customer_name: "小赞",
            phone: "15153448633",
            fault_name: "转向系统",
            fault_detailed: "11111111",
            car_position: "[118.2099,36.810004] ",
            problem_dascribe: "转向转向",
            hand_opinion: "无",
            status: "已处理",
          },
        ],
      };
      this.loading = false;
      this.tableData = res.data;
    },

    //编辑运维人员
    editClick() {
 
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getdata();
    },
    searchSuccess() {
      this.successFormInline.page = 1;
      this.getSuccessdata();
    },
    handleClick() {
      this.formInline.page = 1;
      this.successFormInline.page = 1;
      this.getdata();
      this.getSuccessdata();
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata();
    },
    fautoderFather() {
      this.successFormInline.page = this.page_parm.currentPage;
      this.successFormInline.limit = this.page_parm.pageSize;
      this.getSuccessdata();
    },
    opFather() {
      this.opInline.page = this.pageop.currentPage;
      this.opInline.limit = this.pageop.pageSize;
      this.editClick();
    },
    //显示编辑页面
    handleEdit(row) {
      this.form = {};
      this.dialogFormVisible = true;
      
    },
    //编辑提交方法
    submitEdit() {
      this.dialogFormVisible = false;
     
    },
    //修改状态
    handleStatus(row) {
      this.dialogFault = true;
      console.log("状态变为已完成");

      
    },
    handleSizeChange(val) {
      this.page_parm.pageSize = val;
      this.fautoderFather();
    },
    handleCurrentChange(val) {
      this.page_parm.currentPage = val;
      this.fautoderFather();
    },
    handleSizeChangeOp(val) {
      this.pageop.pageSize = val;
      this.opFather();
    },
    handleCurrentChangeOp(val) {
      this.pageop.currentPage = val;
      this.opFather();
    },
  },
};
</script>
<style>
.tabs_style {
  margin-top: 30px;
  width: 100% !important;
}

#container {
  width: 100%;
  height: 600px;
}

.car_jl {
  margin-right: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/operation_mn/Fault_order.vue